import mem from "mem";

export function RememberThis() {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor
	) {
		descriptor.value = mem( descriptor.value );
	};
}
